import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "select", "container", "copyButton", "languageLabel" ]
  static values = { id: String }

  connect() {
    window.addEventListener("editor:state-changed", this.updateSelectorState)
    this.currentCodeBlockEl = null

    this.languageMap = {
      'auto': 'Авто',
      'javascript': 'JS',
      'typescript': 'TS',
      'html': 'HTML',
      'css': 'CSS',
      'python': 'Python',
      'sql': 'SQL',
      'java': 'Java',
      'json': 'JSON',
      'ruby': 'Ruby'
    }
  }

  disconnect() {
    window.removeEventListener("editor:state-changed", this.updateSelectorState)
  }

  updateSelectorState = (event) => {
    if (event.detail.editorId !== this.idValue) return

    const editor = event.detail.editor

    if (!editor?.isActive('codeBlock')) {
      this.hidePanel()
      return
    }

    const codeBlock = this.getfocusedCodeBlock(editor)
    if (!codeBlock) {
      this.hidePanel()
      return
    }

    this.currentCodeBlockEl = codeBlock
    this.syncLanguageUI(editor)
    this.positionPanel(codeBlock)
  }

  getfocusedCodeBlock(editor) {
    const { node: focusedDomElement } = editor.view.domAtPos(editor.state.selection.anchor)
    if (!focusedDomElement) return null

    const element = focusedDomElement instanceof Element
      ? focusedDomElement
      : focusedDomElement.parentNode

    return element instanceof Element ? element.closest('code') : null
  }

  syncLanguageUI(editor) {
    const currentLanguage = editor.getAttributes('codeBlock').language || 'auto'

    if (!this.selectTarget.classList.contains('hidden')) {
      this.selectTarget.value = currentLanguage
    }

    if (!this.languageLabelTarget.classList.contains('hidden')) {
      const prettyName = this.languageMap[currentLanguage] || currentLanguage
      this.languageLabelTarget.textContent = prettyName
    }
  }

  positionPanel(codeBlock) {
    const blockRect = codeBlock.getBoundingClientRect()
    const parentEl = this.element.closest("[data-controller='rich-editor']")
    const parentRect = parentEl.getBoundingClientRect()

    const topOffset = blockRect.top - parentRect.top - 8

    this.containerTarget.classList.remove("hidden")
    this.containerTarget.style.position = "absolute"
    this.containerTarget.style.top = `${topOffset}px`
    this.containerTarget.style.right = "8px"
    this.containerTarget.style.left = "auto"
    this.containerTarget.style.zIndex = 9
  }

  hidePanel() {
    this.containerTarget.classList.add("hidden")
    this.currentCodeBlockEl = null
    this.resetCopyButton()
  }


  changeLanguage(event) {
    const language = event.target.value
    const customEvent = new CustomEvent("editor:set-language", {
      detail: { editorId: this.idValue, language: language }
    })
    window.dispatchEvent(customEvent)
  }

  copyCode(event) {
    event.preventDefault();
    if (!this.currentCodeBlockEl) return;

    const codeText = this.currentCodeBlockEl.innerText || this.currentCodeBlockEl.textContent;

    navigator.clipboard.writeText(codeText).then(() => {
      this.copyButtonTarget.classList.remove("bg-slate-900", "text-slate-400", "hover:border-white/20", "hover:text-slate-200");
      this.copyButtonTarget.classList.add("bg-green-50", "text-green-700");
      setTimeout(() => this.resetCopyButton(), 2000);

    }).catch(err => {
      console.error("Не удалось скопировать код: ", err);
    });
  }

  resetCopyButton() {
    if (!this.hasCopyButtonTarget) return;
    this.copyButtonTarget.classList.add("bg-slate-900", "text-slate-400", "hover:border-white/20", "hover:text-slate-200");
    this.copyButtonTarget.classList.remove("bg-green-50", "text-green-700");
  }
}
